import React, {useContext, useEffect, useState} from "react";
import {Title} from "../../../../../stories/Title/Title";
import {Button} from "../../../../../stories/Button/Button";
import {useNavigate} from "react-router-dom";
import {
  LicenseTypes,
  Operation,
  PageFor,
} from "../../../../../utils/Enum.types";
import Add from "./Add";
import List from "./List";
import {IObjectKeys} from "../../../../../utils/formTypes";
import {Form, Formik, FormikProps} from "formik";
import {groupingValidation} from "../../../../../utils/validationSchema";
import {AddItemGroup, UpdateItemGroup} from "./queries/mutation";
import {useLazyQuery, useMutation} from "@apollo/client";

import {
  EMPTY_STRING,
  emptyMessage,
  ROWS_PER_PAGE,
} from "../../../../../utils/constants";
import useUrlParams from "../../../../../customHooks/useUrlParams";

import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import {nodeVar, OrderDirection} from "../../../../../utils/commonQueryTypes";
import {AppContext} from "../../../../../context/context";
import MessageModal from "../../../../../customComponents/MessageModal";
import {msgType} from "../../../../../utils/types";
import {MasterDataProps} from "../itemgroup/Index";
import Close from "../../../../../images/Close.svg";
import LoadingModal from "../../../../pages/LoadingModal";
import Navbar from "../../../../common/layout/Navbar";
import {
  AddItemGroupResult,
  AddItemGroupVar,
  AtsItemGroup,
  AtsItemGroupOrderField,
  UpdateItemGroupResult,
  UpdateItemGroupVar,
} from "./queries/types";
import {GetItemGroupNodeById, GetItemGroups} from "./queries/queries";
interface formDataType extends IObjectKeys {
  groupName: string;
  noOfDecimals: number;
}

export interface CommonProps extends MasterDataProps {
  setOperation: React.Dispatch<React.SetStateAction<Operation>>;
  handleClear?: any;
}
export interface AddMasterDataProps extends CommonProps {
  formData: formDataType;
  handleValueChange: (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<formDataType>
  ) => void;
  meta: FormikProps<formDataType>;
  operation: Operation;
}

export interface ListPageProps extends CommonProps {
  setMessage: React.Dispatch<React.SetStateAction<msgType>>;
}

const Grouping = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState(emptyMessage);

  const {user_details} = useLoggedInUserDetails();

  const {state} = useContext(AppContext);

  const [operation, setOperation] = useState(Operation.CREATE);
  const {customer_id} = useUrlParams();
  const [formData, setFormData] = useState<formDataType>({
    groupName: "",
    noOfDecimals: 0,
  });

  const [GetItemGroup, {loading: getGroupLoading}] = useLazyQuery<
    {node: AtsItemGroup},
    nodeVar
  >(GetItemGroupNodeById);

  const [AddGroupDetails, {loading: addGroupLoading}] = useMutation<
    AddItemGroupResult,
    AddItemGroupVar
  >(AddItemGroup, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });
  const [UpdateItemGroupDetails, {loading: updateGroupLoading}] = useMutation<
    UpdateItemGroupResult,
    UpdateItemGroupVar
  >(UpdateItemGroup, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  const handleValueChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
    meta: FormikProps<formDataType>
  ) => {
    const {name, value} = e.target as HTMLInputElement;

    setFormData(() => ({
      ...formData,
      [name]: value,
    }));
    meta.handleChange(e);
  };
  const handleClear = () => {
    const inputElement = document.getElementsByName(
      "groupName"
    )[0] as HTMLInputElement;
    if (inputElement) inputElement.focus();
    setFormData({
      groupName: "",
      noOfDecimals: 0,
    });
  };

  const handleSubmit = async () => {
    if (customer_id) {
      if (operation === Operation.CREATE) {
        const empAdded = AddGroupDetails({
          variables: {
            user_details,
            customerID: customer_id,
            groupName: formData.groupName,
          },
          refetchQueries: [
            {
              query: GetItemGroups,
              variables: {
                after: null,
                customerID: customer_id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsItemGroupOrderField.GROUP_NAME,
                },

                name: EMPTY_STRING,
              },
            },
          ],
        });
        const {data} = await empAdded;

        if (data && data.AddItemGroup) {
          setMessage({
            flag: true,
            message: "Group added successfully",
            operation: Operation.CREATE,
          });
        }
      } else {
        const customerUpdated = UpdateItemGroupDetails({
          variables: {
            user_details,
            itemGrpID: state.groupId,
            groupName: formData.groupName,
          },
          refetchQueries: [
            {
              query: GetItemGroups,
              variables: {
                after: null,
                customerID: customer_id,
                first: ROWS_PER_PAGE,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsItemGroupOrderField.GROUP_NAME,
                },

                name: EMPTY_STRING,
              },
            },
          ],
        });
        const {data} = await customerUpdated;

        if (data && data.UpdateItemGroup) {
          setMessage({
            flag: true,
            message: "Group details updated successfully",
            operation: Operation.CREATE,
          });
        }
      }
    }
  };

  const hanldeClear = () => {
    setFormData({
      groupName: "",
      noOfDecimals: 0,
    });
  };
  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      hanldeClear();
      setOperation(Operation.CREATE);
    }
    setMessage(emptyMessage);
  };

  useEffect(() => {
    if (state.groupId && operation === Operation.UPDATE) {
      GetItemGroup({
        variables: {
          id: state.groupId,
        },
      }).then(({data}) => {
        if (data && data.node) {
          setFormData({
            groupName: data.node.groupName,
            noOfDecimals: 0,
          });
        }
      });
    }
  }, [state.groupId, GetItemGroup, operation]);

  return (
    <>
      <Navbar NavType={LicenseTypes.COMPANY} />
      <div className="master-data--modal--title">
        <Title>Grouping</Title>
      </div>

      <Formik
        initialValues={formData}
        validationSchema={groupingValidation}
        onSubmit={handleSubmit}
        enableReinitialize
        validateOnChange
      >
        {(meta) => {
          return (
            <Form className="master-data">
              <div className="master-data__datablock">
                <div className="master-data__datablock--left">
                  <Add
                    type={PageFor.GENERAL}
                    formData={formData}
                    handleValueChange={handleValueChange}
                    setOperation={setOperation}
                    meta={meta}
                    operation={operation}
                  />
                </div>
                <div className="master-data__datablock--right">
                  <List
                    type={PageFor.GENERAL}
                    setOperation={setOperation}
                    setMessage={setMessage}
                  />
                </div>
              </div>
              <Button mode="save" className="submit" type="submit" />
              <Button mode="clear" type="button" onClick={handleClear} />
              <Button mode="back" type="button" onClick={() => navigate(-1)} />
            </Form>
          );
        }}
      </Formik>
      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
      <LoadingModal
        flag={getGroupLoading || addGroupLoading || updateGroupLoading}
      />
    </>
  );
};

export default Grouping;
